"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AdvancedModal = _interopRequireDefault(require("../../AdvancedModal"));
var _LodashExtensions = require("chaire-lib-common/lib/utils/LodashExtensions");
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
var _OctaviParameters = _interopRequireDefault(require("../../../services/ui/OctaviParameters"));
var _InputSelect = _interopRequireDefault(require("chaire-lib-frontend/lib/components/input/InputSelect"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
class widgetTemporalOptionSelector extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      selectedOptions: _OctaviParameters.default.get(`selectedWidgets.${this.props.uuid}.options`, {})
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.onValueTemporalChange = this.onValueTemporalChange.bind(this);
    this.onValueGeographicalChange = this.onValueGeographicalChange.bind(this);
    this.onValueOnLocationOptionChange = this.onValueOnLocationOptionChange.bind(this);
    this.onValueObjectChange = this.onValueObjectChange.bind(this);
    this.onValueGraphChange = this.onValueGraphChange.bind(this);
    this.onValueStatusChange = this.onValueStatusChange.bind(this);
    this.temporalOptionChoices = [{
      value: "byMonth"
    }, {
      value: "byWeek"
    }, {
      value: "byDay"
    }, {
      value: "none"
    }];
    this.geographicalOptionChoices = [{
      value: "bySR"
    }, {
      value: "bySM"
    }, {
      value: "none"
    }];
    this.statusOptionChoices = [{
      value: "unavailable"
    }, {
      value: "oncoming"
    }, {
      value: "occupied"
    }, {
      value: "free"
    }, {
      value: "none"
    }];
  }
  componentDidMount() {
    _ServiceLocator.default.eventManager.on(`taxi.widget.${this.props.uuid}ManageOptions.request`, this.handleOpen);
  }
  componentWillUnmount() {
    _ServiceLocator.default.eventManager.off(`taxi.widget.${this.props.uuid}ManageOptions.request`, this.handleOpen);
  }
  handleOpen() {
    this.setState({
      isActive: true,
      selectedOptions: _OctaviParameters.default.get(`selectedWidgets.${this.props.uuid}.options`, {})
    });
  }
  handleClose() {
    this.setState({
      isActive: false
    });
  }
  onValueTemporalChange(e) {
    this.setState({
      selectedOptions: _objectSpread(_objectSpread({}, this.state.selectedOptions), {}, {
        temporalOption: e.target.value
      })
    });
  }
  onValueGeographicalChange(e) {
    const actualSelectedOptions = this.state.selectedOptions;
    if (e.target.value === "none" && this.state.selectedOptions.onLocationOption) {
      delete actualSelectedOptions['onLocationOption'];
    }
    if (e.target.value !== "none") {
      actualSelectedOptions['onLocationOption'] = actualSelectedOptions.onLocationOption ? actualSelectedOptions.onLocationOption : "origin";
    }
    this.setState({
      selectedOptions: _objectSpread(_objectSpread({}, actualSelectedOptions), {}, {
        geographicalOption: e.target.value,
        graphOption: e.target.value === "none" && this.state.selectedOptions.graphOption === "spatialDistribution" ? "temporalMean" : this.state.selectedOptions.graphOption
      })
    });
  }
  onValueOnLocationOptionChange(e) {
    this.setState({
      selectedOptions: _objectSpread(_objectSpread({}, this.state.selectedOptions), {}, {
        onLocationOption: e.target.value
      })
    });
  }
  onValueObjectChange(e) {
    this.setState({
      selectedOptions: _objectSpread(_objectSpread({}, this.state.selectedOptions), {}, {
        objectOption: e.target.value,
        graphOption: e.target.value === "none" && this.state.selectedOptions.graphOption === "objectDistribution" ? "temporalMean" : this.state.selectedOptions.graphOption
      })
    });
  }
  onValueGraphChange(e) {
    this.setState({
      selectedOptions: _objectSpread(_objectSpread({}, this.state.selectedOptions), {}, {
        graphOption: e.target.value
      })
    });
  }
  onValueStatusChange(e) {
    this.setState({
      selectedOptions: _objectSpread(_objectSpread({}, this.state.selectedOptions), {}, {
        statusOption: e.target.value
      })
    });
  }
  handleConfirm() {
    _OctaviParameters.default[`selectedWidgets.${this.props.uuid}.options`] = this.state.selectedOptions;
    _ServiceLocator.default.eventManager.emit(`taxi.widget.${this.props.uuid}SelectOptions.update`);
  }
  handleLoad() {}
  renderContainer() {
    const objectChoisesList = ["operators", "driver", "vehicles", "activities", "none"];
    if (objectChoisesList.includes(this.props.object)) {
      objectChoisesList.splice(objectChoisesList.indexOf(this.props.object), 1);
    }
    const objecChoises = objectChoisesList.map(function (choice) {
      return {
        value: choice
      };
    });
    const graphOptionChoices = [{
      value: "temporalMean"
    }];
    if (this.state.selectedOptions.objectOption && this.state.selectedOptions.objectOption !== "none") {
      graphOptionChoices.push({
        value: "objectDistribution"
      });
    }
    if (this.state.selectedOptions.geographicalOption && this.state.selectedOptions.geographicalOption !== "none") {
      graphOptionChoices.push({
        value: "spatialDistribution"
      });
    }
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, this.props.t('octavi:widgetOptions:temporalOption:title')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, /*#__PURE__*/_react.default.createElement(_InputSelect.default, {
      choices: this.temporalOptionChoices,
      t: this.props.t,
      value: this.state.selectedOptions.temporalOption ? this.state.selectedOptions.temporalOption : "none",
      localePrefix: "octavi:widgetOptions:temporalOption",
      onValueChange: e => this.onValueTemporalChange(e),
      noBlank: true
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, this.props.t('octavi:widgetOptions:objectOption:title')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, /*#__PURE__*/_react.default.createElement(_InputSelect.default, {
      choices: objecChoises,
      t: this.props.t,
      value: this.state.selectedOptions.objectOption ? this.state.selectedOptions.objectOption : "none",
      localePrefix: "octavi:widgetOptions:objectOption",
      onValueChange: e => this.onValueObjectChange(e),
      noBlank: true
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, this.props.t('octavi:widgetOptions:geographicalOption:title')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, /*#__PURE__*/_react.default.createElement(_InputSelect.default, {
      choices: this.geographicalOptionChoices,
      t: this.props.t,
      value: this.state.selectedOptions.geographicalOption ? this.state.selectedOptions.geographicalOption : "none",
      localePrefix: "octavi:widgetOptions:geographicalOption",
      onValueChange: e => this.onValueGeographicalChange(e),
      noBlank: true
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, this.props.t('octavi:widgetOptions:onLocationOption:title')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, /*#__PURE__*/_react.default.createElement(_InputSelect.default, {
      choices: [{
        value: "origin"
      }, {
        value: "destination"
      }],
      t: this.props.t,
      value: this.state.selectedOptions.onLocationOption ? this.state.selectedOptions.onLocationOption : "onOrigin",
      localePrefix: "octavi:widgetOptions:onLocationOption",
      onValueChange: e => this.onValueOnLocationOptionChange(e),
      noBlank: true,
      disabled: !(this.state.selectedOptions.geographicalOption && this.state.selectedOptions.geographicalOption !== "none")
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, this.props.t('octavi:widgetOptions:graphOption:title')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, /*#__PURE__*/_react.default.createElement(_InputSelect.default, {
      choices: graphOptionChoices,
      t: this.props.t,
      value: this.state.selectedOptions.graphOption ? this.state.selectedOptions.graphOption : "temporalMean",
      localePrefix: "octavi:widgetOptions:graphOption",
      onValueChange: e => this.onValueGraphChange(e),
      noBlank: true,
      disabled: !(this.state.selectedOptions.objectOption && this.state.selectedOptions.objectOption !== "none" || this.state.selectedOptions.geographicalOption && this.state.selectedOptions.geographicalOption !== "none")
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "oct_widget_option_section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, this.props.t('octavi:widgetOptions:statusOption:title')), /*#__PURE__*/_react.default.createElement("div", {
      className: "_two_column"
    }, /*#__PURE__*/_react.default.createElement(_InputSelect.default, {
      choices: this.statusOptionChoices,
      t: this.props.t,
      value: this.state.selectedOptions.statusOption ? this.state.selectedOptions.statusOption : "none",
      localePrefix: "octavi:widgetOptions:statusOption",
      onValueChange: e => this.onValueStatusChange(e),
      noBlank: true,
      disabled: !this.props.allowStatus
    }))));
  }
  render() {
    const {
      isActive
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_AdvancedModal.default, {
      title: `${this.props.t('octavi:widgetOptions:title')}${this.props.t(`octavi:widgets.${this.props.labelName}.name`)}`,
      t: this.props.t,
      isOpen: isActive,
      container: this.renderContainer(),
      showCancelButton: true,
      showConfirmButton: true,
      closeModal: this.handleClose,
      confirmAction: this.handleConfirm,
      isConfirmButtonDisabled: false
    });
  }
}
exports.default = widgetTemporalOptionSelector;
widgetTemporalOptionSelector.propTypes = {
  t: _propTypes.default.func,
  i18n: _propTypes.default.object,
  activeSection: _propTypes.default.string,
  object: _propTypes.default.string,
  labelName: _propTypes.default.string
};